/**
 * The per-pick consent gate (R3, S3). Selecting a team whose spread is still
 * pending must be blocked until the fan confirms, and canceling must leave
 * the tile unselected. This is the client half of the server's
 * `NEEDS_SPREAD_CONSENT` refusal.
 *
 * Per-pick, never per-account: this component holds no "remember this"
 * state and writes nothing to storage. It is re-raised for every
 * pending-spread selection.
 */
import { Button, Dialog } from "@sportsmet/ui";
import type { JSX } from "react";

import {
  PICK_CONSENT_BODY,
  PICK_CONSENT_CANCEL_LABEL,
  PICK_CONSENT_CONFIRM_LABEL,
  PICK_CONSENT_TITLE,
} from "./pickCopy";

export type typeSpreadConsentDialogProps = {
  open: boolean;
  teamName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function SpreadConsentDialog(
  props: typeSpreadConsentDialogProps,
): JSX.Element {
  return (
    <Dialog
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onCancel();
      }}
      title={PICK_CONSENT_TITLE}
      autoFocus={false}
      footer={
        <>
          <Button
            variant="secondary"
            data-testid="spread-consent-cancel"
            onClick={props.onCancel}
          >
            {PICK_CONSENT_CANCEL_LABEL}
          </Button>
          <Button
            variant="primary"
            data-testid="spread-consent-confirm"
            onClick={props.onConfirm}
          >
            {PICK_CONSENT_CONFIRM_LABEL}
          </Button>
        </>
      }
    >
      <p className="text-body text-ink">
        {PICK_CONSENT_BODY} {props.teamName}
      </p>
    </Dialog>
  );
}
